import { ActionType, createReducer } from 'typesafe-actions';
import * as actions from '../actions';
import { CORE_INITIAL_STATE } from '../constants';
import { CoreState } from '../types';
import * as handlers from './handlers';

type ActionTypes = ActionType<typeof actions>;

export const loggedUserReducer = createReducer<CoreState, ActionTypes>(CORE_INITIAL_STATE)
  .handleAction(actions.setLoggedUser, handlers.setLoggedUser)
  .handleAction(actions.cleanLoggedUser, handlers.cleanLoggedUser);
